import { TagKindSchema, TagSchema } from "@redotech/redo-common-model/tag";
import * as z from "zod";
import { null as zNull } from "zod";

export const editTag = {
  name: "editTag" as const,
  input: z.object({
    oldName: z.string(),
    kind: TagKindSchema,
    newTag: TagSchema,
  }),
  output: zNull(),
};
